import { registerBlockType } from '@wordpress/blocks';
import { InnerBlocks } from '@wordpress/block-editor';
import metadata from './block.json';
import Edit from './Edit';
import './style.scss';

registerBlockType(metadata.name, {
  edit: Edit,
  // Dynamic block: render.php splits each slide's halves across the regions;
  // only the authored slides persist.
  save: () => <InnerBlocks.Content />,
  icon: {
    foreground: '#0061FE',
    src: (
      // A wide media panel, a narrow fixed panel, and the next slide peeking.
      // Inline fill:none required: `foreground` adds .has-colors whose
      // `fill: currentcolor` overrides the SVG fill attribute.
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        style={{ fill: 'none' }}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="2.5" y="6.5" width="10" height="11" rx="1.5" />
        <rect x="14" y="6.5" width="5.5" height="11" rx="1.5" />
        <path d="M21.5 8.5v7" />
      </svg>
    ),
  },
});
